import React from "react";

export default function BuyerProfilePlaceOrderNotice({ onOpenProfile }) {
  return (
    <div
      className="small mb-3 border-bottom p-2 w-100"
      style={{
        backgroundColor: "#fff3cd",
        borderColor: "#ffecb5",
      }}
      role="status"
    >
      Please complete your profile before placing the order.{" "}
      <button
        type="button"
        className="btn btn-link p-0 align-baseline text-decoration-underline"
        onClick={onOpenProfile}
      >
        Complete your profile
      </button>
    </div>
  );
}
